import { ChainId } from './chainId';

export default ChainId.Rinkeby;
